import { render, staticRenderFns } from "./impersonation-bar-component.vue?vue&type=template&id=3a6d9985&scoped=true"
import script from "./impersonation-bar-component.ts?vue&type=script&lang=ts&external"
export * from "./impersonation-bar-component.ts?vue&type=script&lang=ts&external"
import style0 from "./impersonation-bar-component.scss?vue&type=style&index=0&id=3a6d9985&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d9985",
  null
  
)

export default component.exports